import { ISearchResult } from './searchContextInterface';
import { ActionDispatch, createContext, Dispatch, SetStateAction } from 'react';

export const SearchResultContext = createContext<ISearchResult>({
  loading: false,
  artists: null,
  items: null,
  tags: null,
});
export const SearchResultMutatorContext = createContext<Dispatch<SetStateAction<ISearchResult>>>(
  () => {},
);
